import { BaseEnum } from './BaseEnum';

export class TOCStatus extends BaseEnum {
  static readonly DISCHARGED = 'DISCHARGED';

  static readonly INPATIENT = 'INPATIENT';

  static readonly HANDOFF = 'HANDOFF';

  static readonly REHAB = 'REHAB';

  static readonly CLOSED = 'CLOSED';

  static readonly INVALID = 'INVALID';

  get isClosed() {
    return [TOCStatus.CLOSED].includes(this.id);
  }

  static getColor(status: TOCStatus | string) {
    const value = typeof status === 'string' ? status : status?.id;
    switch (value) {
      case TOCStatus.INVALID:
        return 'closed';
      case TOCStatus.CLOSED:
        return 'success';
      default:
        return 'warning';
    }
  }
}

export default TOCStatus;
